import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { t } from '../../../utils/textUtils';

const ErrorState = ({ error }) => {
  return (
    <Box sx={{ p: 3, textAlign: 'center' }}>
      <Typography variant="h6" color="error" gutterBottom>
        {t('TERJADI KESALAHAN')}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {error}
      </Typography>
      <Button 
        variant="contained" 
        onClick={() => window.location.reload()} 
        sx={{ mt: 2 }}
      >
        {t('MUAT ULANG HALAMAN')}
      </Button>
    </Box>
  );
};

export default ErrorState;
